export enum OrderStatus {
  NEW = 'NEW',
  INITIATED = 'INITIATED',
  PROCESSED = 'PROCESSED',
  CANCELLED = 'CANCELLED',
  QUEUED = 'QUEUED',
  EXPIRED = 'EXPIRED',
  DECLINED = 'DECLINED',
  FAILED = 'FAILED'
}
